import type { HTMLAttributes } from "react";

export interface ProgressBarProps extends HTMLAttributes<HTMLDivElement> {
  label: string;
  value: number;
  max?: number;
  valueText?: string;
}

export function ProgressBar({
  label,
  value,
  max = 100,
  valueText,
  className,
  ...props
}: ProgressBarProps) {
  const safeMax = max > 0 ? max : 100;
  const safeValue = Math.min(Math.max(value, 0), safeMax);
  const percent = Math.round((safeValue / safeMax) * 100);
  const displayedValue = valueText ?? `${percent}%`;

  return (
    <div {...props} className={["ui-progress", className].filter(Boolean).join(" ")}>
      <div className="ui-progress__meta">
        <span>{label}</span>
        <span data-numeric>{displayedValue}</span>
      </div>
      <div
        aria-label={label}
        aria-valuemax={safeMax}
        aria-valuemin={0}
        aria-valuenow={safeValue}
        aria-valuetext={displayedValue}
        className="ui-progress__track"
        role="progressbar"
      >
        <div className="ui-progress__bar" style={{ inlineSize: `${percent}%` }} />
      </div>
    </div>
  );
}
